// set to true to stop charging abroad delivery (used while testing payments)
export const DELIVERY_DISABLED = false;

// abroad shipping, priced in USD per amount of items
// vinyl: 1 - 20$, 2 - 28$, 3 - 38$, 4-5 - 50$
const VINYL_DELIVERY_USD = [20, 28, 38, 50, 50];
// cassettes and CDs share one price list: 1 - 8$, 2 - 15$, 3 - 20$, 4-5 - 30$
const DISC_DELIVERY_USD = [8, 15, 20, 30, 30];

const priceForAmount = (amount, prices) => {
  if (!amount || amount < 1) {
    return 0;
  }
  // anything above the last listed amount pays the last price
  return prices[Math.min(amount, prices.length) - 1];
};

export function calculateDeliveryTotalUsd(merch, vinyl, cassette, cd) {
  if (DELIVERY_DISABLED) {
    return 0;
  }

  let total = 0;

  if (merch >= 1 && merch <= 2) {
    total += 10;
  } else if (merch >= 3 && merch <= 4) {
    total += 18;
  } else if (merch >= 5) {
    total += 22;
  }

  total += priceForAmount(vinyl, VINYL_DELIVERY_USD);
  // cassettes and CDs are counted together, not per type
  total += priceForAmount((cassette || 0) + (cd || 0), DISC_DELIVERY_USD);

  return total;
}

// the shop charges the same USD shipping in every language, so the UAH price
// is that amount converted at the current rate
export function calculateDeliveryTotal(merch, vinyl, cassette, cd, usdRate) {
  const usd = calculateDeliveryTotalUsd(merch, vinyl, cassette, cd);

  if (!usd || !usdRate) {
    return 0;
  }

  const uah = usd * usdRate;

  return uah % 10 === 0 ? uah : Math.ceil(uah / 10) * 10;
}
